module.exports = __webpack_public_path__ + "static/media/BamazonTextImage.2f6639d6.png";